import React from 'react';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import { showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';
import ChartBubble from '@/pages/intelligence/components/ChartBubble';
import { transValueFormat } from '../../_config/utils';

export default function LineInstance(props: any) {
  const {
    colors = ECHARTSCOLOR,
    axisLabelData = [],
    seriesData = [],
    dateType,
    titleNow,
    topTitle,
  } = props;

  //默认浮窗内容
  const lineFormatterTooltip = (params: any[]) => {
    return ChartBubble({
      data: params,
      topTitle: topTitle,
      titleNow: titleNow,
      chartType: 'line',
      dateType,
      ifNoBarImg: true,
      isPercent: true,
    });
  };
  const opts = {
    color: colors,
    tooltip: {
      trigger: 'axis',
      lineStyle: {
        color: 'rgba(0,0,0,0.25)',
        width: 2,
        type: 'solid',
      },
      showDelay: 0, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          color: '#96c5eb',
          opacity: '0.01',
          width: 'auto',
        },
        label: {
          backgroundColor: '#6a7985',
        },
      },
      padding: 0,
      borderWidth: 0,
      formatter: function (datas: any) {
        if (!Array.isArray(datas)) {
          return datas;
        }
        //！！将数据转换一下,底层组件不支持自定义数据格式
        const data = datas?.map((item) => {
          return { ...(item || {}), value: transValueFormat(item?.value) };
        });
        return lineFormatterTooltip(data);
      },
      backgroundColor: 'rgba(0,0,0,0)'
    },
    legend: {
      selectedMode: true,
      selected: {},
      itemWidth: 12,
      itemHeight: 10,
      itemGap: 18,
      width: '100%',
      icon: 'circle',
      bottom: 'bottom',
      textStyle: {
        color: '#888',
        fontSize: 12,
      },
    },
    grid: {
      left: '10px',
      right: '4%',
      bottom: '10%',
      containLabel: true,
      top: '10px',
    },
    aria: {},
    xAxis: [
      {
        type: 'category',
        boundaryGap: true,
        data: axisLabelData,
        // data: ['2023-04-01', '2023-05-01', '2023-06-01'],
        axisLine: {
          show: true,
          onZero: false, //当y轴有负数时,让x轴下落在y轴最小值
          lineStyle: {
            color: '#BFBFBF',
            //透明度会展示到虚线，暂时用纯色代替
            // color: '#000',
            // opacity: 0.25,
            width: 1,
          },
        },
        axisLabel: {
          color: '#000',
          align: 'center',
          opacity: 0.45,
          fontSize: 12,
          margin: 10,
          // data: axisLabelData,
          formatter: function (value: string) {
            if (!dateType) {
              return value;
            }
            return showTimeByDateType(value, dateType) || value;
          },
        },
        axisTick: {
          alignWithLabel: true, //x轴刻度线与标签对齐
          lineStyle: {
            color: '#BFBFBF',
            //透明度会展示到虚线，暂时用纯色代替
            // color: '#000',
            // opacity: 0.25,
            width: 1,
          },
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#E5E5E5',
          },
        },
        inverse: false,
        axisLabel: {
          color: 'rgba(0, 0, 0, .45)',
          fontSize: 12,
          formatter: function (value: number) {
            return Math.abs(value * 100) + '%';
          },
        },
        nameTextStyle: {
          color: 'rgba(0, 0, 0, .45)',
          fontSize: 12,
          padding: [0, 50, 0, 0],
        },
        max: 1,
      },
    ],
    series: seriesData,
  };
  return {
    barOption: opts,
  };
}
